<template>
<div id="contact">
    <div v-if="sendFlag">
        <h1 style="padding-top: 0">You message sent successfully !</h1>
    </div>
    <el-form :model="Contact_data" id="contact-form" :rules="rules" ref="contactForm">
        <el-form-item label="Name" prop="name">
            <el-input v-model="Contact_data.name"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="email">
            <el-input v-model="Contact_data.email"></el-input>
        </el-form-item>
        <el-form-item label="Message" prop="message">
            <el-input type="textarea" v-model="Contact_data.message" :autosize="{ minRows: 8, maxRows: 10}"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit_message">send</el-button>
        </el-form-item>
    </el-form>
    <div id="contact-info">
        <h1>Contact Information</h1>
        <p id="contact-content" style="font-size:18px">
            Jiaqi Liu, M.D.
            <br />Cancer Hospital, Chinese Academy of Medical Sciences and Peking Union Medical College
            National Cancer Center/National Clinical Research Center for Cancer
            <br />Position: 17 Panjiayuannanli, Chaoyang, Beijing, 100021, P.R. China
            <br />E-mail: j.liu@cicams.ac.cn
        </p>
    </div>
</div>
</template>

<script>
import axios from "axios";
export default {
    name: "aboutUs",
    data() {
        return {
            Contact_data: {
                name: "",
                email: "",
                message: "",
            },
            rules: {
                name: [{
                    required: true,
                    message: 'Please enter your name',
                    trigger: 'blur'
                }, ],
                email: [{
                        required: true,
                        message: 'Please enter your e-mail',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Please enter your e-mail address in the format',
                        trigger: 'blur'
                    }
                ],
                message: [{
                    required: true,
                    message: 'Please enter your message',
                    trigger: 'blur'
                }, ]
            },
            sendFlag: false
        };
    },
    methods: {
        submit_message() {
            this.$refs["contactForm"].validate((valid) => {
                if (valid) {
                    axios
                        .post("/apis/sendMessage", this.Contact_data)
                        .then(this.sendFlag = true);
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
#contact {
    text-align: justify;
}

#contact-content {
    font-size: 14px;
}

#contact-form {
    width: 800px;
    margin: 0 auto;
}

#contact-info {
    width: 1200px;
    margin: 0 auto;
}
</style>
